import { IBOItem } from "./IBOItem";
export default IBOItem;
